<template>
  <v-container fluid class="pa-4">

    <!-- ================= Filters Section ================= -->
      <v-row dense>
        <v-col cols="6" sm="12">
          <v-card class="pa-4 mb-4 rounded-lg" elevation="2">
            <v-row dense justify="space-between">
              <!-- <v-col cols="4" sm="4">
                <v-autocomplete
                  v-model="filters.branch_id"
                  :items="branches"
                  item-title="name"
                  item-value="id"
                  label="Select Branch"
                  density="compact"
                  variant="outlined"
                />
              </v-col> -->

              <v-col cols="4" sm="4">
                <v-date-input
                  v-model="filters.from_date"
                  label="From Date"
                  density="compact"
                  variant="outlined"
                  prepend-icon=""
                  prepend-inner-icon="mdi mdi-calendar-month"
                  single-line
                  bg-color="grey-lighten-4"
                  autocomplete="off"
                  hide-details
                />
              </v-col>

              <v-col cols="4" sm="4">
                <v-date-input
                  v-model="filters.to_date"
                  label="To Date"
                  density="compact"
                  variant="outlined"
                  prepend-icon=""
                  prepend-inner-icon="mdi mdi-calendar-month"
                  single-line
                  bg-color="grey-lighten-4"
                  autocomplete="off"
                  hide-details
                />
              </v-col>

               <v-col cols="2" sm="2" class="d-flex align-center">
                  <v-btn color="primary" block @click="loadDashboard">
                      <v-icon left>mdi-magnify</v-icon> Filter
                  </v-btn>
                </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>


    <!-- ================= Summary Cards ================= -->
    <v-row dense>
      <v-col cols="12" md="3" v-for="card in summaryCards" :key="card.label">
        <v-card elevation="2">
          <v-card-text>
            <div class="text-caption text-grey">{{ card.title }}</div>
            <div class="text-h5 font-weight-bold">
              {{ card.value }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


    <!-- ================= Low Stock ================= -->
    <!-- <v-card rounded="lg" class="pa-4 mt-6">
      <div class="text-h6 mb-3">Low Stock Alert</div>

      <v-data-table
        :headers="lowStockHeaders"
        :items="dashboard.low_stock"
        density="compact"
        class="elevation-1"
        hide-default-footer
      >
      <template v-slot:item.index="{ index }">
        {{ ++index }}
      </template>
      </v-data-table>
    </v-card> -->


    <!-- ================= Stock Movement Chart ================= -->
    <!-- <v-card rounded="lg" class="pa-4 mt-6">
      <div class="text-h6 mb-3">Stock Movement (In/Out)</div>
      <apexchart
        type="line"
        height="300"
        :options="stockMovementOptions"
        :series="stockMovementSeries"
      />
    </v-card> -->


    <!-- ================= Fast Moving Items ================= -->
    <!-- <v-card rounded="lg" class="pa-4 mt-6">
      <div class="text-h6 mb-3">Fast Moving Items</div>
      <v-data-table
        :headers="movementHeaders"
        :items="dashboard.fast_moving"
        density="compact"
        class="elevation-1"
        hide-default-footer
      >
      <template v-slot:item.index="{ index }">
        {{ ++index }}
      </template>
      </v-data-table>
    </v-card> -->


    <!-- ================= Slow Moving Items ================= -->
    <!-- <v-card rounded="lg" class="pa-4 mt-6">
      <div class="text-h6 mb-3">Slow Moving Items</div>
      <v-data-table
        :headers="movementHeaders"
        :items="dashboard.slow_moving"
        density="compact"
        class="elevation-1"
        hide-default-footer
      >
      <template v-slot:item.index="{ index }">
        {{ ++index }}
      </template>
      </v-data-table>
    </v-card> -->


    <!-- ================= Warehouse Stock Summary ================= -->
    <!-- <v-card rounded="lg" class="pa-4 mt-6">
      <div class="text-h6 mb-3">Warehouse Wise Stock</div>
      <v-data-table
        :headers="warehouseHeaders"
        :items="dashboard.warehouse_stock"
        density="compact"
        class="elevation-1"
        hide-default-footer
      >
        <template v-slot:item.index="{ index }">
          {{ ++index }}
        </template>
       </v-data-table>
    </v-card> -->

    <v-row class="mt-6">
      <v-col cols="12">
        <v-card elevation="2">
          <v-card-title class="text-subtitle-1 font-weight-bold">
            Monthly Payment Overview
          </v-card-title>

          <v-card-text>
            <apexchart
              height="320"
              type="bar"
              :options="chartOptions"
              :series="chartSeries"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>


<script setup>
import { onMounted, reactive, ref, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import ApexChart from "vue3-apexcharts";
import formattedDate from "@/plugins/dateFormatter";
import { fileServerUrl } from "@/store/api";

const store = useStore();

const baseURL = import.meta.env.VITE_API_BASE_URL || "";

const dashboard = reactive({
  summary: {},
  low_stock: [],
  movement_chart: [],
  fast_moving: [],
  slow_moving: [],
  warehouse_stock: []
});

const branches = ref([]);

const filters = reactive({
  branch_id: "",
  from_date: "",
  to_date: ""
});

// Summary Card Data Formatting
const summaryCards = computed(() => {
  if (!summary.value) return []

  return [
    {
      title: 'Total Projects',
      value: summary.value.projects.total_projects
    },
    {
      title: 'Project Amount',
      value: formatCurrency(summary.value.projects.total_project_amount)
    },
    {
      title: 'Paid Amount',
      value: formatCurrency(summary.value.payments.total_paid_amount)
    },
    {
      title: 'Due Amount',
      value: formatCurrency(summary.value.payments.total_due_amount)
    },
    {
      title: 'Upcoming Installments',
      value: summary.value.upcoming_installments
    },
    {
      title: 'Overdue Installments',
      value: summary.value.overdue_installments
    }
  ]
});


const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-BD', {
    style: 'currency',
//   { title: "Warehouse", align:"center", key: "warehouse_name", sortable: false },
//   { title: "Available Qty", align:"center", key: "available_qty", sortable: f
    currency: 'BDT',
    minimumFractionDigits: 0
  }).format(value || 0)
}

// const lowStockHeaders = [
//   { title: "#SL", align: "center", key: "index", width: "7%", sortable: false, },
//   { title: "Product", align:"center", key: "product_name", sortable: false }alse }
// ];

// const movementHeaders = [
//   { title: "#SL", align: "center", key: "index", width: "7%", sortable: false, },
//   { title: "Product", align:"center", key: "product_name", sortable: false },
//   { title: "Qty", align:"center", key: "qty", align:"center", sortable: false }
// ];

// const warehouseHeaders = [
//   { title: "#SL", align: "center", key: "index", width: "7%", sortable: false, },
//   { title: "Warehouse", key: "warehouse_name", align: "center", sortable: false },
//   { title: "Total Qty", key: "total_qty", align:"center", sortable: false },
//   { title: "Total Value", key: "total_value", align:"center", sortable: false  }
// ];

const summary = ref(null)
const monthlyData = ref([])

// const stockMovementOptions = ref({
//   chart: {
//     id: "stock_movement",
//     toolbar: { show: false },
//     zoom: { enabled: false }
//   },

//   stroke: {
//     curve: "smooth",
//     width: 3
//   },

//   xaxis: {
//     categories: [],
//     labels: { rotate: -45 }
//   },

//   yaxis: {
//     title: { text: "Quantity" }
//   },

//   dataLabels: {
//     enabled: false
//   },

//   colors: ["#3b82f6", "#ef4444"],

//   legend: {
//     position: "top"
//   },

//   grid: {
//     borderColor: "#e5e7eb"
//   }
// });

const chartSeries = ref([])
const chartOptions = ref({
  chart: {
    toolbar: { show: false }
  },
  xaxis: {
    categories: []
  },
  plotOptions: {
    bar: {
      columnWidth: '45%',
      borderRadius: 4
    }
  },
  dataLabels: {
    enabled: false
  },
  legend: {
    position: 'top'
  }
})


// const stockMovementSeries = ref([
//   { name: "Stock In", data: [] },
//   { name: "Stock Out", data: [] }
// ]);

// function loadMovementChart() {
//   const labels = dashboard.movement_chart.map(i => i.date);

//   stockMovementOptions.value.xaxis.categories = labels;

//   stockMovementSeries.value = [
//     {
//       name: "Stock In",
//       data: dashboard.movement_chart.map(i => i.in_qty)
//     },
//     {
//       name: "Stock Out",
//       data: dashboard.movement_chart.map(i => i.out_qty)
//     }
//   ];
// }

// async function loadDashboard() {
//   // filters.value.from_date = formattedDate(filters.value.from_date);
//   // filters.value.to_date = formattedDate(filters.value.to_date);
//   const response = await axios.get(`${baseURL}/auth/inventory/dashboard`, filters);
//   Object.assign(dashboard, response.data.data);
//   loadMovementChart();
// }

// async function loadBranches() {
//   const res = await axios.get("/branches");
//   branches.value = res.data.data;
// }

const fetchSummary = async () => {

  // const { data } = await axios.get('/project/dashboard/summary')
  const { data } = await axios.get(`${baseURL}/auth/project/dashboard/summary`, filters);
  summary.value = data
}

const fetchMonthlyPayment = async () => {

  // const { data } = await axios.get('/project/dashboard/monthly-payment')
  const { data } = await axios.get(`${baseURL}/auth/project/dashboard/monthly-payment`);
  monthlyData.value = data

  chartOptions.value.xaxis.categories = data.map(i => i.month)

  chartSeries.value = [
    {
      name: 'Scheduled',
      data: data.map(i => Number(i.scheduled_amount))
    },
    {
      name: 'Received',
      data: data.map(i => Number(i.received_amount))
    }
  ]
}


onMounted(() => {
  fetchSummary()
  fetchMonthlyPayment()
});
</script>

<style>
.dashboard-card {
  background: linear-gradient(135deg, #f8fafc, #eef2ff);
  border: 1px solid #e5e7eb;
}
</style>
